import { render, staticRenderFns } from "./GamesGrid.vue?vue&type=template&id=7df4158a&scoped=true&"
import script from "./GamesGrid.vue?vue&type=script&lang=ts&"
export * from "./GamesGrid.vue?vue&type=script&lang=ts&"
import style0 from "./GamesGrid.vue?vue&type=style&index=0&id=7df4158a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df4158a",
  null
  
)

export default component.exports